const NAME_SPACE = 'EmailPreferences'

const constants = {
  FETCH_EMAIL_PREFERENCES_REQUEST: `${NAME_SPACE}/FETCH_EMAIL_PREFERENCES_REQUEST`,
  FETCH_EMAIL_PREFERENCES_SUCCESS: `${NAME_SPACE}/FETCH_EMAIL_PREFERENCES_SUCCESS`,
  FETCH_EMAIL_PREFERENCES_FAILURE: `${NAME_SPACE}/FETCH_EMAIL_PREFERENCES_FAILURE`,
  FETCH_EMAIL_PREFERENCES: `${NAME_SPACE}/FETCH_EMAIL_PREFERENCES`,

  UPDATE_EMAIL_PREFERENCE_REQUEST: `${NAME_SPACE}/UPDATE_EMAIL_PREFERENCE_REQUEST`,
  UPDATE_EMAIL_PREFERENCE_SUCCESS: `${NAME_SPACE}/UPDATE_EMAIL_PREFERENCE_SUCCESS`,
  UPDATE_EMAIL_PREFERENCE_FAILURE: `${NAME_SPACE}/UPDATE_EMAIL_PREFERENCE_FAILURE`,
  UPDATE_EMAIL_PREFERENCE: `${NAME_SPACE}/UPDATE_EMAIL_PREFERENCE`,

  UNSUBSCRIBE_ALL_REQUEST: `${NAME_SPACE}/UNSUBSCRIBE_ALL_REQUEST`,
  UNSUBSCRIBE_ALL_SUCCESS: `${NAME_SPACE}/UNSUBSCRIBE_ALL_SUCCESS`,
  UNSUBSCRIBE_ALL_FAILURE: `${NAME_SPACE}/UNSUBSCRIBE_ALL_FAILURE`,
  UNSUBSCRIBE_ALL: `${NAME_SPACE}/UNSUBSCRIBE_ALL`,
}

export default constants
